import { gql } from '@generated/gql';

const updateBasketPreferences = gql(`
  mutation UpdateBasketPreferences($basketId: ID!, $input: BasketPreferencesInput!) {
    updateBasketPreferences(basketId: $basketId, input: $input) {
      ...BundleBasket
    }
  }
`);

export { updateBasketPreferences };
